import { css } from '@repo/pandacss/styled-system/css';

export const Divider = () => {
  return (
    <hr
      className={css({
        marginBottom: '4',
        borderTopWidth: 'thin',
        borderTopStyle: 'solid',
        borderTopColor: 'neutral.light',
        borderBottomWidth: 'none',
        borderLeftWidth: 'none',
        borderRightWidth: 'none',
        marginTop: '0',
        marginLeft: '0',
        marginRight: '0',
      })}
    />
  );
};
